/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './Article.css';

class PageInput extends React.Component {
  constructor(props){
    super(props)
    this.state={
      value:props.nowPage
    }
    this.onKeyDown=this.onKeyDown.bind(this)
  }


  onKeyDown=(e)=>{
    const {value}=e.target
    


    if(e.keyCode=='13'){
      // this.getArtJson({pageNum:Number(value)})
      this.props.changePageNum(e.target.value)
      this.props.getArtJson({pageNum:Number(value)})
    }

  }

  componentWillReceiveProps = (nextProps) => {
    if(nextProps.nowPage!=this.props.nowPage){
      this.setState({value:nextProps.nowPage})
    }
  }
  


  render() {
    const {value}=this.state


    return(
      <input className={s.pageInCss}  defaultValue={this.props.nowPage} value={value} onChange={(e)=>this.setState({value:e.target.value})}  onKeyDown={this.onKeyDown}   />
    )


   
  }
}

export default withStyles(s)(PageInput);



// WEBPACK FOOTER //
// src/components/Article/pageInput.js